/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1PersonIdRoles202,
  PutApiV1PersonIdRoles400,
  PutApiV1PersonIdRoles401,
  PutApiV1PersonIdRoles404,
  PutApiV1PersonIdRoles500,
  PutApiV1PersonIdRolesMutationRequest,
  PutApiV1PersonIdRolesMutationResponse,
  PutApiV1PersonIdRolesPathParams,
} from "../../types/personRegisterController/PutApiV1PersonIdRoles.ts";
import { personRolesViewModelSchema } from "../personRolesViewModelSchema.ts";
import { updatePersonRolesViewModelSchema } from "../updatePersonRolesViewModelSchema.ts";

export const putApiV1PersonIdRolesPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PutApiV1PersonIdRolesPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const putApiV1PersonIdRoles202Schema = z.lazy(
  () => personRolesViewModelSchema,
) as unknown as ToZod<PutApiV1PersonIdRoles202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1PersonIdRoles400Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdRoles400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1PersonIdRoles401Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdRoles401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1PersonIdRoles404Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdRoles404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1PersonIdRoles500Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdRoles500>;

export const putApiV1PersonIdRolesMutationRequestSchema = z.lazy(
  () => updatePersonRolesViewModelSchema,
) as unknown as ToZod<PutApiV1PersonIdRolesMutationRequest>;

export const putApiV1PersonIdRolesMutationResponseSchema = z.lazy(
  () => putApiV1PersonIdRoles202Schema,
) as unknown as ToZod<PutApiV1PersonIdRolesMutationResponse>;
